<template>
  <section class="is-flex">
    <div class="is-flex">
      <i
        class="icon cls cls-caret-left has-text-primary is-clickable is-relative xy-t-1 m-r-5"
        @click="setPreviousWeek"
        :data-e2e="TimeEntryCypressAttribute.buttons.PREVIOUS_WEEK"
      ></i>
      <div
        class="has-text-weight-medium"
        :class="[isCurrentWeek ? 'has-text-grey-darker' : 'is-link has-text-primary']"
        @click="setCurrentWeek"
        :data-e2e="TimeEntryCypressAttribute.buttons.CURRENT_WEEK"
      >
        {{ displayPeriod }}
      </div>
      <i
        class="icon cls cls-caret-right has-text-primary is-relative xy-t-1 m-l-5"
        :class="[isCurrentWeek ? 'has-text-grey-lighter' : 'is-clickable has-text-primary']"
        @click="setNextWeek"
        :data-e2e="TimeEntryCypressAttribute.buttons.NEXT_WEEK"
      ></i>
    </div>
  </section>
</template>
<script>
import dayjs from 'dayjs';
import { datesOfWeek } from '@/modules/core/app/helpers/DateHelper';
import { DateFormat } from '@/modules/core/app/constants/date.constants';
import { TimeEntryCypressAttribute } from '@/modules/timeentry/constants/TimeEntryCypressAttribute';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'TimeEntryWeeksNavigator',
  emits: ['on-week-change'],
  props: {
    showWeekend: {
      type: Boolean,
      default: false
    },
    initialWeekDate: {
      type: String,
      default: () => null
    }
  },
  static: {
    TimeEntryCypressAttribute
  },
  data() {
    return {
      weekDates: datesOfWeek(
        this.initialWeekDate ? dayjs(this.initialWeekDate) : dayjs(),
        this.showWeekend
      )
    };
  },
  computed: {
    startDate() {
      return this.weekDates[0];
    },
    endDate() {
      return this.weekDates.at(-1);
    },
    displayPeriod() {
      return `${dayjs(this.startDate).format(DateFormat.MONTH_DAY)} - ${dayjs(this.endDate).format(
        DateFormat.MONTH_DAY
      )}`;
    },
    isCurrentWeek() {
      return this.weekDates[0] === datesOfWeek(dayjs(), this.showWeekend)[0];
    }
  },
  methods: {
    setPreviousWeek() {
      this.setWeekDates(dayjs(this.startDate).subtract(1, 'week'));
    },
    setNextWeek() {
      if (this.isCurrentWeek) {
        return;
      }

      this.setWeekDates(dayjs(this.startDate).add(1, 'week'));
    },
    setCurrentWeek() {
      if (this.isCurrentWeek) {
        return;
      }

      this.setWeekDates();
    },
    setWeekDates(startDate) {
      this.weekDates = datesOfWeek(startDate, this.showWeekend);
      this.$emit('on-week-change', this.weekDates);
    }
  }
};
</script>
